let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("IlyWH")).then(() => parcelRequire('5JVEf'));